import React, { useState } from "react";
import i18n from 'utils/i18n'
import ThemedSafeAreaComponentTop from 'components/atoms/ThemedSafeAreaTop'
import ThemedLayout from 'components/atoms/ThemedLayout'
import HomeBookStartPlace from 'scenes/home/book/start/_tabs/place'
import { viewModes } from 'scenes/home/book/start/_constants/modes'
import HomeBookStartInvitations from 'scenes/home/book/start/_tabs/invitations'
import HelperString from 'utils/helper-string'
import TabbedContent from 'components/molecules/TabbedContent'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import HelperTimeslotGroups from 'utils/helper/HelperTimeslotGroups'
import { useRoute } from '@react-navigation/native'
import _ from 'lodash'
import useRouteParametersForcedGuids from 'utils/hooks/use-route-parameters-forced-guids'
import { TESTID } from '_shared/config/testID'
import useRouteHomeHelper from 'utils/hooks/use-route-home-helper'

const HomeBookStartScene = () => {
	
	useRouteHomeHelper();
	
	const [ topTabbar, setTopTabbar ] = useState( null )
	const _timeslotGroups = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_GROUPS];
	} );
	
	const route = useRoute();
	const _forcedGuids = useRouteParametersForcedGuids( route );
	
	let canSendInvitations = HelperTimeslotGroups.canSendInvitations( _timeslotGroups );
	let showBackButton = false;
	
	const tabBarItems = [ {
		key: viewModes.MODE_PLACE,
		text: i18n.t('page.create.index.title'),
		scene: ( props ) => {
			return <HomeBookStartPlace {...props} />;
		}
	}];
	
	if( _.size( _forcedGuids ) ){
		canSendInvitations = false;
		showBackButton = true;
	}
	
	
	// Only show invitations when invitations are enabled
	if( canSendInvitations ) {
		tabBarItems.push( {
			key: viewModes.MODE_INVITATIONS,
			text: i18n.t( 'page.booking.calendar.invitations.title' ),
			scene: ( props ) => {
				return <HomeBookStartInvitations {...props} />;
			}
		});
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>
			
			<ThemedLayout
				contentWidth="narrow"
				title={ i18n.t('page.create.index.title') }
				topTabbar={ topTabbar }
				showBackButton={ showBackButton}
				testID={ TESTID.HOME.BOOK.SCREENS.INDEX }
				topNavigation>
				
				<TabbedContent
					key={ HelperString.hash('profile-tabs' ) }
					topTabbar={ setTopTabbar }
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default HomeBookStartScene;
